import { call, delay, put, takeLatest } from "redux-saga/effects";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";

import { ZoneActionTypes, ZoneActions } from "../../../actionTypes/master/zoneActionTypes";
import {
  createZoneApi,
  editZoneDataByIdApi,
  getZoneDataByIdApi,
  getZoneListApi,
  deleteZoneApi
} from "../../requests/master/zoneRequests";
import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";
import { getZoneList, setZoneDataById, setZoneList, setZoneListPageCount } from "../../../actions/master/zoneActions";


function* createZoneHandler(action: ZoneActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createZoneApi, action.payload);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getZoneListHandler(action: ZoneActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");

    const { data } = yield call(getZoneListApi, action.payload);

    if (data.status) {
      yield put(setZoneList(data?.data?.rows));
      yield put(setZoneListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getZoneDataByIdHandler(action: ZoneActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getZoneDataByIdApi, action.payload);
    if (data.status) {
      yield put(setZoneDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editZoneDataByIdHandler(action: ZoneActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editZoneDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getZoneList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* deleteZoneHandler(action: ZoneActionTypes) {
  try {
    yield startLoader("transparent");

    const { data } = yield call(deleteZoneApi, action.payload);

    if (data.status) {
      toast.success(data?.message, {
        position: "top-right",
      });

      // refresh zone list after delete
      yield put(getZoneList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

// zone sagas
export default function* zoneSaga() {
  yield takeLatest(ZoneActions.CREATE_ZONE, createZoneHandler);
  yield takeLatest(ZoneActions.GET_ZONE_LIST, getZoneListHandler);
  yield takeLatest(ZoneActions.GET_ZONE_DATA_BY_ID, getZoneDataByIdHandler);
  yield takeLatest(ZoneActions.EDIT_ZONE_DATA_BY_ID, editZoneDataByIdHandler);
  yield takeLatest(ZoneActions.DELETE_ZONE, deleteZoneHandler);
}
